module.exports = __webpack_public_path__ + "img/typless_logo.aa71ceb.svg";